import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Menu from "../components/Menu";
import { fetchUserData, refreshAccessToken } from "../actions/user";
import { fetchMenuData } from "../actions/sidemenu";
import { fetchSystemInfo } from "../actions/systeminfo";
import { fetchWhatNewData } from "../actions/dashboard";

const mapStateToProps = (state) => ({
  menuData: state.menu.menuData,
  isFetching: state.menu.isFetching,
  error: state.menu.error,
  user: state.login.user,
  reloadFolderFlag: state.menu.reloadFolderFlag,
  systemInfo: state.systemInfo.systemInfo
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      refreshAccessToken,
      fetchUserData,
      fetchMenuData,
      fetchSystemInfo,
      fetchWhatNewData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
